import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Fab from '@mui/material/Fab';
import React, { useRef, useState } from 'react';
import { Typography } from '@mui/material';
import Popover from '@mui/material/Popover';

const PREFIX = 'HelpHint';

const classes = {
  padding: `${PREFIX}-padding`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by span. Changed to span to fix DOM nesting warnings.
const Root = styled('span')(({ theme }) => ({
  [`& .${classes.padding}`]: {
    padding: theme.spacing(2),
    width: '300px',
  },
}));

export const HelpHint = props => {
  const { text, anchorEL, children, anchorOrigin, transformOrigin, iconSize, ...rest } = props;

  const [open, setOpen] = useState(false);
  const internalAnchorEl = useRef();

  return (
    <Root>
      <Fab size='small' onClick={() => setOpen(!open)} ref={internalAnchorEl} {...rest}>
        <HelpIcon style={{ width: iconSize }} />
      </Fab>
      <Popover
        open={open}
        anchorEl={!!anchorEL ? anchorEL.current : internalAnchorEl.current}
        onClose={() => setOpen(false)}
        anchorOrigin={anchorOrigin || { vertical: 'center', horizontal: 'right' }}
        transformOrigin={transformOrigin || { vertical: 'center', horizontal: 'left' }}
      >
        <Typography className={classes.padding}>{children}</Typography>
      </Popover>
    </Root>
  );
};
